var RegistrationFormPanel = function () {
	"use strict";

    	const windowWidth = window.innerWidth;
    	var forms = new forms4i();
    	var accordions = new getAccordions4i();
	var recaptchaSiteKey, recaptchaActionName;
	var errorMsg = '<div class="infoText textRed text15 textSemiBold padding10" aria-live="assertive" aria-atomic="true">We\'re sorry, an error has occurred.  Please refresh the page and try again.</div>';
	var panel = '<div id="ErrorBox" class="ErrorMsgPanel" aria-live="assertive" aria-atomic="true">' +
                        		'<h3 class="validationHeading" id="ErrorTitle">Please correct the following errors and resubmit:</h3>' +
                        		'<ul><li class="errorItem"></li></ul></div>';
    	const ajaxActions = (function () {
        	const antiForgeryToken = { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "" },
		verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "",
		 
        	// save user registration form
			saveUserRegistrationForm = async function (user, payment, ccAuth, oasisOrderId) {
				formEvents.ShowSpinnerOverlay(true, document.getElementById("loadingGuestUserForm"));
				payment.PaymentTypeID = parseInt(payment.PaymentTypeID);
				payment.IsAuthorized = payment.IsAuthorized.toLowerCase() == "false" ? false : true; 
				payment.IsToken =  payment.IsToken.toLowerCase() == "false" ? false : true;
				oasisOrderId = parseInt(oasisOrderId);
				// Check if grecaptcha is defined
				// if not, try to fetch the script again 
				if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
				
				// need to show an error if recaptcha script still isn't available
				if(typeof grecaptcha == "undefined"){
					showRegistrationError();
				}else{
					grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
						let data = { 
							Register: user, 
							Payment: payment, 
							CCAuth: ccAuth, 
							OasisOrderId: oasisOrderId, 
							RecaptchaActionName: recaptchaActionName, 
							RecaptchaToken: token 
						};
								
						fetch('/payment/registeruserform', { 
							method: 'POST', 
							body: JSON.stringify(data), 
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken, "RequestVerificationToken": verificationToken }
						}).then(function(response){
							return  (response.ok) ? response.json() : []; // response.json() returns a promise
						}).then(function(response){
							formEvents.ShowSpinnerOverlay(false, document.getElementById("loadingGuestUserForm"));
							if (response.Success) {
								window.location.href = response.RedirectUrl;
							} else {
								document.getElementById("divGuestUserForm").getElementsByClassName("errorText")[0].innerHTML = response.Message;
								if (document.getElementById("divGuestUserForm").querySelector(".ErrorMsgPanel") && document.getElementById("divGuestUserForm").querySelector(".ErrorMsgPanel").querySelector("a")) {
									document.getElementById("divGuestUserForm").querySelector(".ErrorMsgPanel").querySelector("a").focus();
								}
								forms.serverValidation(document.getElementById("divGuestUserForm").querySelector(".ErrorMsgPanel"));
								document.getElementById("divGuestUserForm").scrollIntoView({ top: 0, behavior: "smooth" });
							}
						}).catch(function(error){
							showRegistrationError();
						});
					});
				}
			},
			showRegistrationError = () => {
				document.getElementById("divGuestUserForm").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', panel);
				document.getElementsByClassName("errorItem")[0].innerHTML = 'We\'re sorry, an error has occurred.  Please refresh the page and try again.';
				document.getElementById("divGuestUserForm").scrollIntoView({ behavior: "smooth" });
				formEvents.ShowSpinnerOverlay(false, document.getElementById("loadingGuestUserForm"));
			},

        	loginUser = async function (login) {
        		// Check if grecaptcha is defined
			// if not, try to fetch the script again 
			if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
			
			// need to show an error if recaptcha script still isn't available
			if(typeof grecaptcha == "undefined"){
				showLoginError();
			}else{
				grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName}).then(function (token) {
					var salesOrderId = "";
					if (document.getElementsByClassName("recaptchaSiteKey")[0]) {
						recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value;
					}
					if (document.getElementsByClassName("recaptchaActionName")[0]) {
						recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value;
					}
					if (document.getElementById("salesOrderId")) {
						salesOrderId = document.getElementById("salesOrderId").value;
					}
					
					let data = {
						Email: login.Email, 
						Password: login.Password, 
						SalesOrderGuid : salesOrderId, 
						RecaptchaActionName : recaptchaActionName, 
						RecaptchaToken : token  
					};
					fetch('/payment/login', { 
						method: 'POST', 
						body: JSON.stringify(data), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken,  "RequestVerificationToken": verificationToken }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.Success) {
		                        		location.reload();
		                    		} else {
	    	                    			document.getElementById("divLoginUserForm").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', panel);                    		
							if (response.error == "recaptchaNotVerified") {
								document.getElementsByClassName("errorItem")[0].innerHTML= '<a href="' + response.recaptchaVerificationUrl + '" tabindex="0" class="errorItem">Send an email to verify your account.</a>';
							}
							else {
	    	                    				document.getElementsByClassName("errorItem")[0].innerHTML = response.Message;
	    	                    			}
	    	                    			if (document.getElementById("divLoginUserForm").querySelector(".ErrorMsgPanel").querySelector("a")) {
	                            			document.getElementById("divLoginUserForm").querySelector(".ErrorMsgPanel").querySelector("a").focus();
	                            		}
							document.getElementById("divLoginUserForm").scrollIntoView({ top: 0, behavior: "smooth" });
							document.getElementById("Email").classList.add("input-validation-error");
							document.getElementById("Email").setAttribute("aria-invalid", "true");
							document.getElementById("Email").removeAttribute("tabindex");
							document.getElementById("Password").classList.add("input-validation-error");
							document.getElementById("Password").setAttribute("aria-invalid", "true");
							document.getElementById("Password").removeAttribute("tabindex");
		                    		}
					}).catch(function(error){
						showLoginError();
					});
				});
			}
        	},
        	
        	showLoginError = () => {
        		document.getElementById("divLoginUserForm").getElementsByClassName("formHeading")[0].insertAdjacentHTML('afterend', panel);
        		document.getElementsByClassName("errorItem")[0].innerHTML = 'We\'re sorry, an error has occurred.  Please refresh the page and try again.';
        		document.getElementById("divLoginUserForm").scrollIntoView({behavior: "smooth"});
        	},

        	logoutUser = function () {
			fetch('/payment/logout', { 
				method: 'POST', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verificationToken,  "RequestVerificationToken": verificationToken}
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if (response.Success) {
                        		location.reload();
                    		}
			}).catch(function(error){
				document.getElementById("divCartNotifications").insertAdjacentHTML('afterbegin', errorMsg);
            			document.getElementById("divCartNotifications").scrollIntoView({behavior: "smooth"});
			});
        	},

        	getLoginForm = function () {
			fetch('/registration/loginform', { 
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				formEvents.InitLoginForm(response);
			}).catch(function(error){
				document.getElementById("divLoginUserForm").insertAdjacentHTML('afterend', errorMsg);
	        		formEvents.ShowSpinnerOverlay(false, document.getElementById("loadingloginUserForm"));
            			document.getElementById("divLoginUserForm").scrollIntoView({behavior: "smooth"});
			});
        	},

        	getUserRegistrationForm = function (cardform) {
			fetch('/registration/registeruserform', { 
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				formEvents.InitRegisterUserForm(response, cardform);
                		document.getElementById("loginPanel").innerHTML = "";
			}).catch(function(error){
				document.getElementById("divGuestUserForm").insertAdjacentHTML('afterend', errorMsg);
	        		formEvents.ShowSpinnerOverlay(false, document.getElementById("loadingGuestUserForm"));
            			document.getElementById("divGuestUserForm").scrollIntoView({behavior: "smooth"});
			});
        	};

        	return {
           	 	SaveUserRegistrationForm: saveUserRegistrationForm,
            		LoginUser: loginUser,
            		LogoutUser: logoutUser,
            		GetLoginForm: getLoginForm,
            		GetRegisterUserForm: getUserRegistrationForm
        	};
	}()),

	formEvents = (function () {
		const setForm_UserIsRegistered = function () {
            		addHide(['#guestUserHeader']);
            		addHide(['#loginPanel']);
            		removeHide(['#signedInPanel']);
        	};

        	const setForm_SignIn = function () {
            		showSpinnerOverlay(true, document.getElementById("loadingloginUserForm"));
            		removeHide(['#loginHeader']);
            		ajaxActions.GetLoginForm();
        	};

        	const initLoginForm = function (loginForm) {
        		showSpinnerOverlay(false, document.getElementById("loadingloginUserForm"));
            		document.getElementById("divLoginUserForm").innerHTML = loginForm;
            		if (document.getElementsByClassName("recaptchaSiteKey")[0]) {
				recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value;
			}
			if (document.getElementsByClassName("recaptchaActionName")[0]) {
				recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value;
			}
            		document.getElementById("divLoginUserForm").querySelector("input").focus();
            		document.getElementById("divLoginUserForm").scrollIntoView({ top: 0, behavior: "smooth" });

            		document.getElementById("cancelLoginLink").addEventListener("click", function (e) {
            			e.preventDefault();
            			clearSignInForm();
    			});

          		document.getElementById("btnSubmitLogin").addEventListener("click", function(e){
          			e.preventDefault();
          			forms.ClearValidation();
                		document.getElementById("Password").style.backgroundColor = "";
                		document.getElementById("Email").style.backgroundColor = "";
          			forms.formValidation(document.getElementById("divLoginUserForm"), loginUser, e);
          		});
          		
          		forms.BindPasswordButtons();
        	};

        	const setForm_RegisterUser = function (cardForm) {
            		showSpinnerOverlay(true, document.getElementById("loadingGuestUserForm"));
            		removeHide(['#divGuestUser']);
            		addHide(['#loginHeader', '#loginPanel', '#headerPanelText']);
            		ajaxActions.GetRegisterUserForm(cardForm);
		};

        	const initRegisterUserForm = function (registerUserForm, cardForm) {
        		showSpinnerOverlay(false, document.getElementById("loadingGuestUserForm"));
            		document.getElementById("divGuestUserForm").innerHTML = registerUserForm;
			document.getElementById("divGuestUserForm").querySelector("input").focus();
			document.getElementById("divGuestUserForm").scrollIntoView({ top: 0, behavior: "smooth" });
			forms.BindPasswordButtons();
			
			forms.MaskPhoneNumber(document.getElementById("phoneMask"), document.getElementById("Phone"));
			forms.MaskPhoneNumber(document.getElementById("phoneMask"), document.getElementById("MobileNumber"));

            		if (cardForm) {      			
                		document.getElementById("divSaveCard").innerHTML = cardForm;
                    		document.getElementById("divSaveCard").classList.remove('hide');
            		}
            		
            		document.getElementById("loginPanel").classList.remove("invisible");
                    			
			document.getElementById("saveCard").addEventListener("change", function (e) {
				forms.ShowSaveCardName(document.getElementById("saveCard"), document.getElementById("saveCardName"), null);
			});

            		document.getElementById("btnSubmitRegisterUserForm").addEventListener("click", function(e){
            			e.preventDefault();
            			forms.formValidation(document.getElementById("divGuestUserForm"), saveUserRegistrationForm, e);
            		});
        	};

        	const clearSignInForm = function () {
            		accordions.close(document.getElementById("loginUserBody"));
            		if(document.getElementById("divLoginUserForm").querySelector("#ErrorBox")){
            			document.getElementById("divLoginUserForm").querySelector("#ErrorBox").parentNode.removeChild(document.getElementById("divLoginUserForm").querySelector("#ErrorBox"));
            		}
            		document.getElementById('Password').value = "";
            		document.getElementById("Password").classList.remove("input-validation-error");
            		document.getElementById("Password").parentNode.querySelector(".errorMessage").classList.add("hide");
            		document.getElementById('Email').value = "";
            		document.getElementById("Email").classList.remove("input-validation-error");
            		document.getElementById("Email").parentNode.querySelector(".errorMessage").classList.add("hide");      		
        	};

        	const removeHide = function (ids) {
            		for(var i = 0; i < ids.length; i++){
        			document.querySelector(ids[i]).classList.remove("hide");
        		}
        	};

        	const addHide = function (ids) {
        		for(var i = 0; i < ids.length; i++){
        			document.querySelector(ids[i]).classList.add("hide");
        		}
        	};

        	const saveUserRegistrationForm = function () {
            		const form = document.getElementById("divGuestUserForm");
            		//get form
            		const user = {
                		Email: form.querySelector("#Email").value,
                		Password: form.querySelector("#Password").value,
                		ConfirmPassword: form.querySelector("#ConfirmPassword").value,
                		FirstName: form.querySelector("#FirstName").value,
                		LastName: form.querySelector("#LastName").value,
                		CompanyName: form.querySelector("#CompanyName").value,
                		Address1: form.querySelector("#Address1").value,
                		Address2: form.querySelector("#Address2").value,
                		City: form.querySelector("#City").value,
                		State: form.querySelector("#State").value,
                		ZipCode: form.querySelector("#ZipCode").value,
                		Phone: form.querySelector("#Phone").value,
                		Ext: form.querySelector("#Ext").value,
                		MobileNumber: form.querySelector("#MobileNumber").value
            		};

            		const card = document.getElementById("divSaveCard");
            		const billingAddress = {
                		FirstName: form.querySelector("#BillingAddress_FirstName").value,
                		LastName: form.querySelector("#BillingAddress_LastName").value,
                		CompanyName: form.querySelector("#BillingAddress_CompanyName").value,
                		Address1: form.querySelector("#BillingAddress_Address1").value,
                		Address2: form.querySelector("#BillingAddress_Address2").value,
                		City: form.querySelector("#BillingAddress_City").value,
                		State: form.querySelector("#BillingAddress_State").value,
                		ZipCode: form.querySelector("#BillingAddress_ZipCode").value,
                		Phone: form.querySelector("#BillingAddress_Phone").value
            		};
            		
			if (form.querySelector("#saveCard")) {
				form.querySelector("#saveCard").value = form.querySelector("#saveCard").checked;
			}

            		const payment = {
                		IsSaved: form.querySelector('#saveCard').checked,
                		SavedName: form.querySelector("#saveCardName").value ? form.querySelector("#saveCardName").value : forms.GetCreditCardName(form.querySelector('#CardNumber').value),
                		CardExpirationMonth: form.querySelector('#CardExpirationMonth').value,
                		CardExpirationYear: form.querySelector('#CardExpirationYear').value,
                		CardNumber: form.querySelector('#CardNumber').value,
                		CardName: form.querySelector('#CardName').value,
                		CardCCV: form.querySelector('#CardCCV').value,
                		PaymentTypeID: form.querySelector('#PaymentTypeID').value,
                		IsAuthorized: form.querySelector('#IsAuthorized').value,
                		CardPrefix: form.querySelector('#CardPrefix').value,
                		IsToken: form.querySelector('#IsToken').value,
                		Address: billingAddress
            		};

	     		const ccAuth = form.querySelector('#CreditCardAuth').value;	     
	     		const oasisOrderId = document.getElementById('Cart_UserCart_OasisOrderID').value;

            		//add save card
            		ajaxActions.SaveUserRegistrationForm(user, payment, ccAuth, oasisOrderId);
        	};

        	const loginUser = function () {
            		const form = document.getElementById("divLoginUserForm");
            		const login = {
                		Email: form.querySelector("#Email").value,
                		Password: form.querySelector("#Password").value
            		};
            		ajaxActions.LoginUser(login);
        	};
		
		const loadingIcon = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
		
        	const showSpinnerOverlay = function (show, elem) {
            		if (show === true) {
                		elem.classList.remove("hide");
                		elem.querySelector(".spinnerCtrPg").innerHTML = loadingIcon;
            		}
            		else {
                		elem.classList.add("hide");
                		elem.querySelector(".spinnerCtrPg").innerHTML = "";
            		}
        	};

        	return {
            		ClearSignInForm: clearSignInForm,
            		InitLoginForm: initLoginForm,
            		InitRegisterUserForm: initRegisterUserForm,
            		SetForm_UserIsRegistered: setForm_UserIsRegistered,
            		SetForm_SignIn: setForm_SignIn,
            		SetForm_RegisterUser: setForm_RegisterUser,
            		ShowSpinnerOverlay: showSpinnerOverlay
        	};
	}());
	
	if(document.getElementById("signOutLink")) document.getElementById("signOutLink").addEventListener("click", ajaxActions.LogoutUser);
	
	return {
        	SetForm_UserIsRegistered: formEvents.SetForm_UserIsRegistered,
        	SetForm_SignIn: formEvents.SetForm_SignIn,
        	SetForm_RegisterUser: formEvents.SetForm_RegisterUser
	};
}